import { Box } from "@chakra-ui/react";
import SettingsHeader from "../elements/SettingsHeader";
import SettingsDescription from "../elements/SettingsDescription";
import LenderPermissions from "./UserTypes/ManagePermissions";
import { useTenant } from "modules/tenant/providers/tenant-provider";

const Permissions = () => {
  const { user } = useTenant();
  if (user.type === "borrower") return null;
  return (
    <Box>
      <Box mt={"50px"}>
        <SettingsHeader title="User Permissions" />
        <SettingsDescription text="Every member has user permissions based on their role type. Select the role to edit and save changes." />
      </Box>

      <Box mt={"50px"}>
        <LenderPermissions userType="lender" />
      </Box>
    </Box>
  );
};

export default Permissions;
